import { Link } from 'react-router-dom'
import type { BlogPost } from '../../lib/blog/types'

/** Compact card for blog index / category / related lists. */
export default function PostCard({ post }: { post: BlogPost }) {
  return (
    <article className="rounded-2xl border border-black/5 bg-surface p-6 hover:-translate-y-0.5 hover:shadow-soft transition">
      <Link to={`/blog/${post.slug}`} className="block">
        <span className="inline-block text-[0.72rem] uppercase tracking-wide text-accent-dark font-semibold mb-3">
          {post.categoryLabel}
        </span>
        <h3 className="text-lg font-bold text-ink leading-snug m-0">{post.title}</h3>
        <p className="text-[0.92rem] text-ink-soft mt-2 mb-0">{post.description}</p>
      </Link>
    </article>
  )
}
